import Hero from "../components/Hero";
import Features from "../components/Features";
import DemoSection from "../components/DemoSection";

export default function MainScreen() {
  return (
    <div>
      <Hero />
      <Features />
      <DemoSection />
    </div>
  );
}
